// extracted by mini-css-extract-plugin
module.exports = {"alertsIconRoot":"WH78dTDU","unreadBadge":"IbTn0SHt"};